/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React, { Component } from "react"
import "./TRCButton.css"

export default class TRCButton extends Component {
    constructor(props) {
        super(props)
        this.onClick = this.onClick.bind(this)
    }

    get link() {
        let val = "#button"
        if (this.props.link) {
            val = this.props.link
        }
        return val
    }

    onClick(e) {
        if (this.link !== "#button" && !this.props.onClick) {
            return
        }

        e.preventDefault()
        if (this.props.onClick && !this.props.disabled) {
            this.props.onClick(e)
        }
    }

    render() {
        var buttonClass = this.props.className ? this.props.className + " " : ""
        buttonClass += this.props.ghost ? "ghost " : ""
        buttonClass += this.props.secondary ? "secondary " : ""
        buttonClass += this.props.warning ? "warning " : ""
        buttonClass += this.props.disabled ? "disabled " : ""
        buttonClass += this.props.whoops ? "whoops " : ""
        buttonClass += this.props.full ? "full " : ""

        var extras = {}
        if (this.props.id) {
            extras["id"] = this.props.id
        }

        let trk = this.props.trk
        if (!trk && this.props.track) {
            trk = this.props.track
        }
        let trkPage = "false"
        if (this.props.trkPage) {
            trkPage = this.props.trkPage
        }

        return (
            <a
                {...extras}
                data-trk={trk}
                href={this.link}
                className={`TRCButton ${buttonClass}`}
                onClick={this.onClick}
            >
                {this.props.children}
            </a>
        )
    }
}
